"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _tokensStylex = require("web/shared/tokens.stylex.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const styles = exports.styles = {
  wrapper: {
    width: "xh8yej3",
    maxWidth: "x1dwg165",
    boxSizing: "x9f619",
    marginTop: "xdj266r",
    marginBottom: "xat24cr",
    marginLeft: "x8x9d4c",
    marginInlineStart: null,
    marginInlineEnd: null,
    marginRight: "xack27t",
    paddingTop: "x1bw24hb x10rgq7r",
    paddingBottom: "x117aka2 x1x8epk1",
    paddingLeft: "x1oqrxb4 xvr2pop",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    paddingRight: "xlwr664 x91jxnp",
    $$css: true
  },
  wrapperWide: {
    maxWidth: "x1hv4mr",
    $$css: true
  },
  title: {
    fontSize: "xbw2k6l",
    fontWeight: "x1s688f",
    marginTop: "xdj266r",
    marginBottom: "x1nhhxel",
    color: "x10kmngs",
    $$css: true
  },
  body: {
    fontSize: "x1603h9y xgjxlv3",
    lineHeight: "xa7kkou",
    color: "x10kmngs",
    overflowWrap: "xj0a0fe",
    $$css: true
  }
};